// Strings which are == the field names for custom lure in nop
export const categoryConstants = {
    BASECOLOR: 'BaseColor',
    BODYWORK: 'Bodywork & Patterns',
    EYES: 'Eyes',
    TAILDETAILS: 'Tail Details',
    FINSGEELS: 'Fins & Geels',
    TUNING: 'Tuning',
    CATEGORIES: 'Categories'
}

export const subCategoryConstants = {
    SHADOW: 'Shadow',
    IRIS: 'Iris',
    PUPILS: 'Pupils',
    ANALFIN: 'Anal Fin',
    PECTORALFIN: 'Pectoral Fin',
    DORSALFIN: 'Dorsal Fin',
    PELVICFIN: 'Pelvic Fin',
    FINTUNING: 'Fin Tuning',
    FULLTAIL: 'Full Tail',
    HALFTAIL: 'Half Tail',
    TAILTIP: 'Tail Tips & Tuning',
    LARGEDOTS: 'Large Dots',
    SMALLDOTS: 'Small Dots & Extras',
    STRIPES: 'Stripes',
    BACKCOLOR: 'Back Color',
    LATERALLINE: 'Lateral Line',
    BELLYSPRAY: 'Belly Spray',
    CHEEK: 'Cheek',
    FIRSTSTROKE: 'First Stroke',
    SECONDSTROKE: 'Second Stroke',
    FULLCLAWS: 'Full Claws',
    CLAWTIPS: 'Claw Tips',
    ARMS: 'Arms',
    LEGS: 'Legs'
}
export const baseImage = window.baseImage.baseImage ? window.baseImage.baseImage.ImageUrl : '#';
export const blankImage = window.blankImage.blankImage ? window.blankImage.blankImage.ImageUrl : '#';
export const startWizard = 0;

/**
 * The model for the lure images. Imageurls are replaced when the user clicks an image
 * blankImage is the default for no selected image.
 * baseImage is the default lure base.
 * REPRESENTS THE ORDER IN WHICH THE IMAGES ARE STACKED
 */
export const defaultLure = {
    baseColor: {
        imageUrl: baseImage,
        category: categoryConstants.BASECOLOR
    },
    // bodywork: {
    //     imageUrl: blankImage,
    //     category: categoryConstants.BODYWORK
    // },
    firstStroke: {
        imageUrl: blankImage,
        category: subCategoryConstants.FIRSTSTROKE
    },
    secondStroke: {
        imageUrl: blankImage,
        category: subCategoryConstants.SECONDSTROKE
    },
    backColor: {
        imageUrl: blankImage,
        category: subCategoryConstants.BACKCOLOR
    },
    lateralLine: {
        imageUrl: blankImage,
        category: subCategoryConstants.LATERALLINE
    },
    largeDots: {
        imageUrl: blankImage,
        category: subCategoryConstants.LARGEDOTS
    },
    smallDots: {
        imageUrl: blankImage,
        category: subCategoryConstants.SMALLDOTS
    },
    stripes: {
        imageUrl: blankImage,
        category: subCategoryConstants.STRIPES
    },
    bellySpray: {
        imageUrl: blankImage,
        category: subCategoryConstants.BELLYSPRAY
    },
    cheek: {
        imageUrl: blankImage,
        category: subCategoryConstants.CHEEK
    },
    fullClaws: {
        imageUrl: blankImage,
        category: subCategoryConstants.FULLCLAWS
    },
    clawTips: {
        imageUrl: blankImage,
        category: subCategoryConstants.CLAWTIPS
    },
    fullTail: {
        imageUrl: blankImage,
        category: subCategoryConstants.FULLTAIL
    },
    halfTail: {
        imageUrl: blankImage,
        category: subCategoryConstants.HALFTAIL
    },
    tailTip: {
        imageUrl: blankImage,
        category: subCategoryConstants.TAILTIP
    },
    shadow: {
        imageUrl: blankImage,
        category: subCategoryConstants.SHADOW
    },
    iris: {
        imageUrl: blankImage,
        category: subCategoryConstants.IRIS
    },
    pupils: {
        imageUrl: blankImage,
        category: subCategoryConstants.PUPILS
    },
    analFin: {
        imageUrl: blankImage,
        category: subCategoryConstants.ANALFIN
    },
    pectoralFin: {
        imageUrl: blankImage,
        category: subCategoryConstants.PECTORALFIN
    },
    dorsalFin: {
        imageUrl: blankImage,
        category: subCategoryConstants.DORSALFIN
    },
    pelviclFin: {
        imageUrl: blankImage,
        category: subCategoryConstants.PELVICFIN
    },
    finTuning: {
        imageUrl: blankImage,
        category: subCategoryConstants.FINTUNING
    },
    arms: {
        imageUrl: blankImage,
        category: subCategoryConstants.ARMS
    },
    legs: {
        imageUrl: blankImage,
        category: subCategoryConstants.LEGS
    }
}


/**
 * used to prevent stepping past teh first or last category when switching views
 * with buttons
 */
export const categoryLimits = {
    max: 5,
    min: 0
}

/**
 * Model for the category / subcategory hierarchy. Ids are used to switch views and sort categories
 */
export const categories = [
    {
        id: 0,
        active: null,
        selectedImage: -1,
        category: categoryConstants.BASECOLOR,
        imageUrl: null,
        attributeId: null,
        imageId: null,
        subCategories: []
    },
    {
        id: 1,
        selectedImage: -1,
        category: categoryConstants.BODYWORK,
        subCategories: [
            {
                id: 1.1,
                active: null,
                selectedImage: -1,
                category: subCategoryConstants.FIRSTSTROKE,
                imageUrl: null,
                attributeId: null,
                imageId: null
            },
            {
                id: 1.2,
                active: null,
                selectedImage: -1,
                category: subCategoryConstants.SECONDSTROKE,
                imageUrl: null,
                attributeId: null,
                imageId: null
            }
        ]
    },
    {
        id: 2,
        selectedImage: -1,
        category: categoryConstants.TUNING,
        subCategories: [
            {
                id: 2.1,
                active: null,
                selectedImage: -1,
                category: subCategoryConstants.BACKCOLOR,
                imageUrl: null,
                attributeId: null,
                imageId: null
            },
            {
                id: 2.2,
                active: null,
                selectedImage: -1,
                category: subCategoryConstants.LATERALLINE,
                imageUrl: null,
                attributeId: null,
                imageId: null
            },
            {
                id: 2.3,
                active: null,
                selectedImage: -1,
                category: subCategoryConstants.LARGEDOTS,
                imageUrl: null,
                attributeId: null,
                imageId: null
            },
            {
                id: 2.4,
                active: null,
                selectedImage: -1,
                category: subCategoryConstants.SMALLDOTS,
                imageUrl: null,
                attributeId: null,
                imageId: null
            },
            {
                id: 2.5,
                active: null,
                selectedImage: -1,
                category: subCategoryConstants.STRIPES,
                imageUrl: null,
                attributeId: null,
                imageId: null
            },
            {
                id: 2.6,
                active: null,
                selectedImage: -1,
                category: subCategoryConstants.BELLYSPRAY,
                imageUrl: null,
                attributeId: null,
                imageId: null
            },
            {
                id: 2.7,
                active: null,
                selectedImage: -1,
                category: subCategoryConstants.CHEEK,
                imageUrl: null,
                attributeId: null,
                imageId: null
            },
            {
                id: 2.8,
                active: null,
                selectedImage: -1,
                category: subCategoryConstants.FULLCLAWS,
                imageUrl: null,
                attributeId: null,
                imageId: null
            },
            {
                id: 2.9,
                active: null,
                selectedImage: -1,
                category: subCategoryConstants.CLAWTIPS,
                imageUrl: null,
                attributeId: null,
                imageId: null
            },
            {
                id: 2.91,
                active: null,
                selectedImage: -1,
                category: subCategoryConstants.ARMS,
                imageUrl: null,
                attributeId: null,
                imageId: null
            },
            {
                id: 2.92,
                active: null,
                selectedImage: -1,
                category: subCategoryConstants.LEGS,
                imageUrl: null,
                attributeId: null,
                imageId: null
            }
        ]
    },
    {
        id: 3,
        selectedImage: -1,
        category: categoryConstants.TAILDETAILS,
        subCategories: [
            {
                id: 3.1,
                active: null,
                selectedImage: -1,
                category: subCategoryConstants.FULLTAIL,
                imageUrl: null,
                attributeId: null,
                imageId: null
            },
            {
                id: 3.2,
                active: null,
                selectedImage: -1,
                category: subCategoryConstants.HALFTAIL,
                imageUrl: null,
                attributeId: null,
                imageId: null
            },
            {
                id: 3.3,
                active: null,
                selectedImage: -1,
                category: subCategoryConstants.TAILTIP,
                imageUrl: null,
                attributeId: null,
                imageId: null
            }

        ]
    },
    {
        id: 4,
        selectedImage: -1,
        category: categoryConstants.EYES,
        subCategories: [
            {
                id: 4.1,
                active: null,
                selectedImage: -1,
                category: subCategoryConstants.SHADOW,
                imageUrl: null,
                attributeId: null,
                imageId: null
            },
            {
                id: 4.2,
                active: null,
                selectedImage: -1,
                category: subCategoryConstants.IRIS,
                imageUrl: null,
                attributeId: null,
                imageId: null
            },
            {
                id: 4.3,
                active: null,
                selectedImage: -1,
                category: subCategoryConstants.PUPILS,
                imageUrl: null,
                attributeId: null,
                imageId: null
            }
        ]
    },
    {
        id: 5,
        selectedImage: -1,
        category: categoryConstants.FINSGEELS,
        subCategories: [
            {
                id: 5.1,
                active: null,
                selectedImage: -1,
                category: subCategoryConstants.ANALFIN,
                imageUrl: null,
                attributeId: null,
                imageId: null
            },
            {
                id: 5.2,
                active: null,
                selectedImage: -1,
                category: subCategoryConstants.PELVICFIN,
                imageUrl: null,
                attributeId: null,
                imageId: null
            },
            {
                id: 5.3,
                active: null,
                selectedImage: -1,
                category: subCategoryConstants.PECTORALFIN,
                imageUrl: null,
                attributeId: null,
                imageId: null
            },
            {
                id: 5.4,
                active: null,
                selectedImage: -1,
                category: subCategoryConstants.DORSALFIN,
                imageUrl: null,
                attributeId: null,
                imageId: null
            },
            {
                id: 5.5,
                active: null,
                selectedImage: -1,
                category: subCategoryConstants.FINTUNING,
                imageUrl: null,
                attributeId: null,
                imageId: null
            },
        ]
    }
]